import { Contact } from "components/Contact";
import { Hero } from "components/Hero";
import { Meta } from "components/Meta";
import { Page } from "components/Page";
import { PeopleHero } from "components/PeopleHero";
import { RelatedItemsWrapper } from "components/RelatedItems";
import { Slices } from "components/Slices";
import { SpacingSection } from "components/SpacingSection";

export const PeoplePage = ({ doc, preview }) => {
  const {
    availability,
    body,
    city,
    contact_email,
    contact_tel,
    contact_title,
    contact_whatsapp,
    email,
    image,
    job_title,
    name,
    phone,
    related_items_title,
    related_items,
    seo_description,
    seo_image,
    seo_title,
    services,
    website,
  } = doc.data;

  const renderContact =
    contact_title || contact_email || contact_tel || contact_whatsapp;
  const renderHero = image || job_title || name;
  const renderRelated =
    (related_items?.length > 0 && related_items[0].title) ||
    related_items_title;
  const renderSlices = body?.length > 0;
  const renderMeta =
    city || services || availability || phone || email || website;

  return (
    <Page
      description={seo_description}
      image={seo_image}
      preview={preview}
      title={seo_title}
      withLightFooter={renderContact && !renderRelated}
    >
      {renderHero && (
        <PeopleHero
          image={{ src: image?.url, alt: image?.alt }}
          jobTitle={job_title}
          label={getHeroLabel(doc.type)}
          link={getHeroLink(doc.type)}
          title={name}
        />
      )}
      {renderMeta && (
        <Meta
          meta={getMetaData({
            city,
            services,
            availability,
            phone,
            email,
            website,
          })}
        />
      )}
      {renderSlices && <Slices data={body} />}
      {renderContact && (
        <Contact
          email={contact_email}
          subtext={null}
          tel={contact_tel}
          title={contact_title}
          whatsapp={contact_whatsapp}
        />
      )}
      {renderRelated && (
        <SpacingSection>
          <RelatedItemsWrapper
            related_items={related_items}
            related_items_title={related_items_title}
          />
        </SpacingSection>
      )}
    </Page>
  );
};

function getMetaData({ city, services, availability, phone, email, website }) {
  const meta = [];

  if (city) {
    meta.push({ icon: "location", label: "Locatie", value: city });
  }

  if (services) {
    meta.push({ icon: "level", label: "Services", value: services });
  }

  if (availability) {
    meta.push({
      icon: "calendar",
      label: "Beschikbaarheid",
      value: availability,
    });
  }

  if (phone) {
    meta.push({
      icon: "phone",
      label: "Telefoonnummer",
      value: phone,
      url: `tel:${phone}`,
    });
  }

  if (email) {
    meta.push({
      icon: "mail",
      label: "E-mailadres",
      value: email,
      url: `mailto:${email}`,
    });
  }

  if (website) {
    meta.push({
      icon: "website",
      label: "Website",
      value: website
        .replace("https://", "")
        .replace("http://", "")
        .replace("www.", "")
        .replace(/\/$/, ""),
      url: website,
    });
  }

  return meta;
}

function getHeroLabel(type) {
  const options = {
    coach_detail: "Coaches",
    team_detail: "Team",
    teacher_detail: "Docenten",
  };

  return options[type];
}

function getHeroLink(type) {
  const options = {
    coach_detail: { type: "coach_overview" },
    team_detail: { type: "team_overview" },
    teacher_detail: { type: "teacher_overview" },
  };

  return options[type];
}
